var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTeuronaWhiteLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 25,
    viewBox: "0 0 20 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.1121 2.30576V22.2891C12.1121 23.586 11.0376 24.5948 9.7678 24.5948C8.44912 24.5948 7.42348 23.538 7.42348 22.2891V2.30576C7.37464 1.05681 8.44912 0 9.7678 0C10.4027 0 10.9888 0.288221 11.4284 0.672515C11.8679 1.10485 12.1121 1.68129 12.1121 2.30576Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M19.4855 7.73399V11.4809C19.4855 12.7778 18.411 13.7866 17.0924 13.7866C15.7737 13.7866 14.748 12.7298 14.748 11.4809V7.73399C14.748 6.43699 15.8225 5.42822 17.0924 5.42822C17.7273 5.42822 18.3134 5.71644 18.7529 6.10074C19.2413 6.53307 19.4855 7.10951 19.4855 7.73399Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M4.73747 11.5291V17.6778C4.73747 18.9748 3.66299 19.9836 2.39315 19.9836C1.07447 19.9836 0.0488281 18.9268 0.0488281 17.6778V11.5291C0.0488281 10.2321 1.12331 9.17529 2.39315 9.17529C3.02807 9.17529 3.61415 9.46351 4.05371 9.84781C4.44443 10.2801 4.73747 10.8566 4.73747 11.5291Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M17.1432 19.4553C18.4379 19.4553 19.4875 18.423 19.4875 17.1495C19.4875 15.8761 18.4379 14.8438 17.1432 14.8438C15.8484 14.8438 14.7988 15.8761 14.7988 17.1495C14.7988 18.423 15.8484 19.4553 17.1432 19.4553Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M2.34432 8.21456C3.63906 8.21456 4.68864 7.18223 4.68864 5.90879C4.68864 4.63535 3.63906 3.60303 2.34432 3.60303C1.04959 3.60303 0 4.63535 0 5.90879C0 7.18223 1.04959 8.21456 2.34432 8.21456Z",
    fill: "white"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeuronaWhiteLogo);
export default __webpack_public_path__ + "static/media/teurona-white-logo.830b77ad0bba7d221658715db8d6258a.svg";
export { ForwardRef as ReactComponent };